import { Link } from "react-router-dom";
import { Logo } from "@/components/Header";
import { openWhatsApp, WhatsAppIcon } from "@/components/Cta";

const COLS = [
  {
    title: "服务",
    links: [
      { to: "/tiktok-shop-setup", label: "TikTok Shop 开店咨询" },
      { to: "/tiktok-shop-management", label: "店铺管理与代运营" },
      { to: "/product-optimisation", label: "商品优化" },
      { to: "/content-strategy", label: "内容方向规划" },
      { to: "/services", label: "全部服务" },
    ],
  },
  {
    title: "公司",
    links: [
      { to: "/about", label: "关于 TKShopMY" },
      { to: "/faq", label: "常见问题" },
      { to: "/blog", label: "电商资讯" },
      { to: "/contact", label: "联系我们" },
    ],
  },
  {
    title: "法律信息",
    links: [
      { to: "/privacy-policy", label: "隐私政策" },
      { to: "/terms", label: "服务条款" },
      { to: "/disclaimer", label: "品牌声明" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-ink text-paper" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-5 py-16 md:px-8 md:py-20">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Logo light />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-paper/60">
              马来西亚 TikTok Shop 商家拓展与运营支持团队。协助本地商家了解 TikTok Shop、
              评估产品、准备开店，并提供后续运营支持。
            </p>
            <p className="mt-3 max-w-xs text-xs leading-relaxed text-paper/45">
              支持 TikTok Shop 开店、运营、一件代发及无需自行囤货合作咨询。
            </p>
            <button
              onClick={() => openWhatsApp("footer", { text: "WhatsApp 咨询" })}
              className="mt-6 flex items-center gap-2 rounded-full bg-lime px-5 py-2.5 text-sm font-semibold text-ink transition-transform hover:-translate-y-0.5"
              data-testid="footer-chat-button"
              data-location="footer"
            >
              <WhatsAppIcon size={15} />
              WhatsApp 咨询
            </button>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="mb-4 text-xs font-semibold uppercase tracking-[0.18em] text-lime">{col.title}</p>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link to={l.to} className="text-sm text-paper/65 transition-colors hover:text-paper">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 border-t border-paper/10 pt-8">
          <p className="max-w-3xl text-xs leading-relaxed text-paper/40">
            TKShopMY 是独立电商服务提供商，并非 TikTok 或 TikTok Shop 官方机构、官方代理、
            授权代表或关联公司。TikTok、TikTok Shop 及相关商标均属于其各自权利所有者。
          </p>
          <p className="mt-4 text-xs text-paper/40">
            © {new Date().getFullYear()} TKShopMY — 马来西亚电商运营与咨询团队
          </p>
        </div>
      </div>
    </footer>
  );
}
